export default __webpack_public_path__ + "static/media/cardano_color1.fd5ea3cf.svg";